import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import LoadingModal from './components/modals/LoadingModal';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import ImagemModal from './components/modals/ImagemModal';
import './css/Imagem.css';
import Toolbar from './components/Toolbar';

function Imagens() {
  const [imagens, setImagens] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState(false);
  const [imagemSelecionada, setImagemSelecionada] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const token = localStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const vinculo = JSON.parse(localStorage.getItem('vinculo') || 'null');
  const cnpjSelecionado = (localStorage.getItem('cnpj') || vinculo?.escola?.cnpj || vinculo?.cnpj || '')
    .replace(/\D/g, '');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  const getImagemCnpjEntidade = (img) => {
    return (
      img?.cnpjEntidade ||
      img?.CNPJ_ENTIDADE ||
      img?.idEscola ||
      img?.id_escola ||
      img?.ID_ESCOLA ||
      ''
    );
  };

  const getImagemOrientacao = (img) => {
    return (
      img?.orientacao ||
      img?.ORIENTACAO ||
      img?.id?.orientacao ||
      ''
    );
  };
  const normalizeCnpj = (value) => (value || '').toString().replace(/\D/g, '');

  const getImagemBase64 = (img) => {
    if (!img) {
      return '';
    }
    if (typeof img === 'string') {
      return img;
    }

    // Suporte para payload no formato Node Buffer serializado: { type: 'Buffer', data: [...] }
    const bytes = Array.isArray(img) ? img : (img?.type === 'Buffer' && Array.isArray(img?.data) ? img.data : null);
    if (!bytes) {
      return '';
    }

    try {
      // Converte em blocos para evitar stack overflow com imagens maiores
      const chunkSize = 0x8000;
      let binary = '';
      for (let i = 0; i < bytes.length; i += chunkSize) {
        const chunk = bytes.slice(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
      }
      return btoa(binary);
    } catch (error) {
      console.error('Falha ao converter imagem para Base64:', error);
      return '';
    }
  };

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }
    if (!cnpjSelecionado) {
      showDefaultModal('error', 'Selecione uma entidade antes de acessar esta página.');
      navigate('/home');
      return;
    }
    
    setLoading(true);
    axios
      .get(`${API_BASE_URL.IMAGEM}/cnpj/${cnpjSelecionado}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        const lista = Array.isArray(result.data) ? result.data : [];
        const imagensDaEscola = lista.sort((first, second) =>
          getImagemOrientacao(first).localeCompare(getImagemOrientacao(second))
        );

        console.log('Imagens API (total):', lista.length);
        console.log('Imagens API escola:', cnpjSelecionado, imagensDaEscola.length);
        setImagens(imagensDaEscola);
      })
      .catch(error => {
        console.error('Erro ao obter imagens:', error);
        console.error('Detalhes do erro:', error.response?.data || error.message);
        const errorMessage = error.response?.data?.message || error.message || 'Erro ao carregar imagens.';
        showDefaultModal('error', errorMessage);
        setImagens([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar, cnpjSelecionado, navigate, showDefaultModal, token]);

  function handleDelete(imagem) {
    showConfirmModal('delete', () => handleConfirmDelete(imagem));
  }

  function handleConfirmDelete(imagem) {
    const cnpjEntidade = getImagemCnpjEntidade(imagem);
    const orientacao = getImagemOrientacao(imagem);
    axios
      .delete(`${API_BASE_URL.IMAGEM}/delete/${cnpjEntidade}/${orientacao}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        showDefaultModal('success', 'Imagem excluída com sucesso!');
        setAtualizar(prev => !prev);
        setImagemSelecionada(null);
      })
      .catch(error => {
        console.error('Erro ao excluir imagem:', error);
        showDefaultModal('error', 'Erro ao excluir a imagem!');
      });
  }

  function handleEdit(imagem) {
    setImagemSelecionada(imagem);
    setShowModal(true);
  }

  function handleNew() {
    setImagemSelecionada(null);
    setShowModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
    setImagemSelecionada(null);
  }

  function handleSaveSuccess() {
    setAtualizar(prev => !prev);
    setImagemSelecionada(null);
  }

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const imagensFiltradas = Array.isArray(imagens)
    ? imagens.filter(img => {
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(getImagemOrientacao(img)).includes(normalizedBusca) ||
          normalizeString(getImagemCnpjEntidade(img)).includes(normalizedBusca)
        );
      })
    : [];

  const getOrientacaoLabel = (orientacao) => {
    return orientacao === 'R' ? 'Retrato' : orientacao === 'P' ? 'Paisagem' : orientacao;
  };

  const getImagePreview = (img) => {
    const imageBase64 = getImagemBase64(img?.img);
    if (imageBase64) {
      return `data:image/png;base64,${imageBase64}`;
    }
    return null;
  };

  const getImageSize = (img) => {
    const imageBase64 = getImagemBase64(img?.img);
    if (!imageBase64) {
      return '-';
    }
    return `${(imageBase64.length * 0.75 / 1024).toFixed(2)} KB`;
  };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Imagens da Escola" icon="bi-image" />
        <PageContent style={{ paddingBottom: 0 }}>
          <Toolbar>
              <button
                className="btn btn-success btn-sm botao-igual d-inline-flex align-items-center"
                onClick={handleNew}
                title="Cadastrar nova imagem"
              >
                <i className="bi bi-plus-circle me-1"></i>
                Nova
              </button>
              <button
                className="btn btn-warning btn-sm botao-igual d-inline-flex align-items-center"
                disabled={!imagemSelecionada}
                onClick={() => handleEdit(imagemSelecionada)}
                title="Editar imagem selecionada"
              >
                <i className="bi bi-pencil me-1"></i>
                Editar
              </button>
              <button
                className="btn btn-danger btn-sm botao-igual d-inline-flex align-items-center centralizar-se-impar"
                disabled={!imagemSelecionada}
                onClick={() => handleDelete(imagemSelecionada)}
                title="Excluir imagem selecionada"
              >
                <i className="bi bi-trash me-1"></i>
                Excluir
              </button>
            <div className="toolbar-search d-flex align-items-center gap-2">
              <div className="input-group input-group-sm flex-grow-1">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por orientação..."
                  value={filtro}
                  onChange={e => setFiltro(e.target.value.toUpperCase())}
                  style={{ textTransform: 'uppercase', fontVariant: 'normal' }}
                />
              </div>
            </div>
          </Toolbar>

          <LoadingModal loading={isLoading} />

          <div
            className="table-responsive-sm shadow-lg"
            style={{ flex: '1 1 auto', overflowY: 'auto', minHeight: 0 }}
          >
            <table className="table table-hover table-striped table-sm small">
              <thead className="table-secondary sticky-top bg-light" style={{ zIndex: 1 }}>
                <tr>
                  <th scope="col" className="px-2" style={{ width: '100px' }}>
                    Preview
                  </th>
                  <th scope="col" className="px-2">
                    CNPJ Entidade
                  </th>
                  <th scope="col" className="px-2">
                    Orientação
                  </th>
                  <th scope="col" className="px-2 d-none d-md-table-cell">
                    Tamanho
                  </th>
                </tr>
              </thead>
              <tbody>
                {!isLoading &&
                  imagensFiltradas.map((imagem, index) => (
                    <tr
                      key={`${getImagemCnpjEntidade(imagem)}-${getImagemOrientacao(imagem)}`}
                      className={
                        imagemSelecionada &&
                        getImagemCnpjEntidade(imagemSelecionada) === getImagemCnpjEntidade(imagem) &&
                        getImagemOrientacao(imagemSelecionada) === getImagemOrientacao(imagem)
                          ? 'table-primary'
                          : ''
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          imagemSelecionada &&
                          getImagemCnpjEntidade(imagemSelecionada) === getImagemCnpjEntidade(imagem) &&
                          getImagemOrientacao(imagemSelecionada) === getImagemOrientacao(imagem)
                        ) {
                          setImagemSelecionada(null);
                        } else {
                          setImagemSelecionada(imagem);
                        }
                      }}
                    >
                      <td className="px-2">
                        {getImagePreview(imagem) ? (
                          <img
                            src={getImagePreview(imagem)}
                            alt="Preview"
                            style={{
                              maxWidth: '80px',
                              maxHeight: '60px',
                              objectFit: 'contain',
                            }}
                          />
                        ) : (
                          <i className="bi bi-image" style={{ fontSize: '2rem' }}></i>
                        )}
                      </td>
                      <td className="px-2">{getImagemCnpjEntidade(imagem)}</td>
                      <td className="px-2">
                        {getOrientacaoLabel(getImagemOrientacao(imagem))}
                      </td>
                      <td className="px-2 d-none d-md-table-cell">
                        {getImageSize(imagem)}
                      </td>
                    </tr>
                  ))}
                {!isLoading && imagensFiltradas.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center text-muted py-3">
                      Nenhuma imagem encontrada
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <ConfirmModal {...setConfirmModal} />
          <DefaultModal {...setDefaultModal} />
        </PageContent>
      </ResponsiveShadow>

      {showModal && (
        <ImagemModal
          show={showModal}
          imagem={imagemSelecionada}
          onClose={handleCloseModal}
          onSave={handleSaveSuccess}
        />
      )}
    </Layout>
  );
}

export default Imagens;
